// extracted by mini-css-extract-plugin
export default {"productCarousel":"I1-z"};